export default "__VITE_ASSET__6c93072f__"